import { render, staticRenderFns } from "./indcator-compose.vue?vue&type=template&id=4712d549&scoped=true&"
import script from "./indcator-compose.vue?vue&type=script&lang=ts&"
export * from "./indcator-compose.vue?vue&type=script&lang=ts&"
import style0 from "./indcator-compose.vue?vue&type=style&index=0&id=4712d549&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4712d549",
  null
  
)

export default component.exports